export const ATTEMPT_LINK_POS_FAILED_MSG = 'Failed to link POS';

export const ACCESS_DENIED_CODE = '401';

export const COPYRIGHT_TEXT_1 = 'Copyright @ 2022 Vourity AB';
export const COPYRIGHT_TEXT_2 = 'All rights reserved.';

export const LANGUAGES = [
  {
    value: 'sv-SE',
    label: 'Swedish',
    image: 'images/swedish.svg',
    locale: 'sv',
  },
  {
    value: 'en-US',
    label: 'English',
    image: 'images/english.svg',
    locale: 'en',
  },
];

export const GENERIC_ERROR_MSG = 'Something when wrong, please try again later.';

export const ENGLISH_LANG = 'en';

export const SWEDISH_LANG = 'se';

export const ENGLISH_LANG_SHORT = 'en-US';

export const SWEDISH_LANG_SHORT = 'sv-SE';

export const PSP_TYPE_STRIPE = 'stripe';

export const PSP_TYPE_SWISH = 'swish';

export const COUNTRIES_EXTN = [
  { code: 'se', name: 'Sweden', extn: '+46' },
  { code: 'dk', name: 'Denmark', extn: '+45' },
  { code: 'no', name: 'Norway', extn: '+47' },
  { code: 'fi', name: 'Finland', extn: '+358' },
  { code: 'de', name: 'Germany', extn: '+49' },
  { code: 'fr', name: 'France', extn: '+33' },
  { code: 'es', name: 'Spain', extn: '+34' },
  { code: 'ee', name: 'Estonia', extn: '+372' },
  { code: 'pl', name: 'Poland', extn: '+48' },
  { code: 'nl', name: 'Netherlands', extn: '+31' },
  { code: 'at', name: 'Austria', extn: '+43' },
  { code: 'ie', name: 'Ireland', extn: '+353' },
  { code: 'cy', name: 'Cyprus', extn: '+357' },
  { code: 'lv', name: 'Latvia', extn: '+371' },
  { code: 'lu', name: 'Luxembourg', extn: '+352' },
  { code: 'pt', name: 'Portugal', extn: '+351' },
  { code: 'sk', name: 'Slovakia', extn: '+421' },
  { code: 'si', name: 'Slovenia', extn: '+386' },
  { code: 'gr', name: 'Greece', extn: '+30' },
  { code: 'mt', name: 'Malta', extn: '+356' },
  { code: 'it', name: 'Italy', extn: '+39' },
  { code: 'hr', name: 'Croatia', extn: '+385' },
  { code: 'mx', name: 'Mexico', extn: '+52' },
  { code: 'pt', name: 'Portugal', extn: '+351' },
  { code: 'ch', name: 'Switzerland', extn: '+41' },
  { code: 'gb', name: 'United Kingdom', extn: '+44' },
  { code: 'ae', name: 'United Arab Emirates', extn: '+971' },
];

export const PREFERRED_COUNTRIES = ['se', 'dk', 'no', 'fi', 'ie', 'gb', 'ae', 'ch', 'pt'];

export const PAYMENT_STATUS_PAID = 'paid';

export const PAYMENT_STATUS_NOT_FOUND = 'NOT FOUND';

export const PAYMENT_STATUS_PENDING = 'pending';

export const PAYMENT_STATUS_OK = 'OK';

export const FETCHING_PAYMENT_STATUS_FAILED_MSG = 'Failed to fetch payment status.';

export const FETCHING_WEBSHOP_FAILED_MSG = 'Failed to fetch webshop.';

export const FETCHING_PRODUCT_FAILED_MSG = 'Failed to fetch product.';

export const FETCHING_CART_FAILED_MSG = 'Failed to fetch cart.';

export const ADDING_PRODUCT_FAILED_MSG = 'Failed to add product.';

export const REMOVING_PRODUCT_FAILED_MSG = 'Failed to remove product.';

export const CHECKOUT_SESSION_FAILED_MSG = 'Failed to checkout session.';

export const PRODUCT_OUT_OF_STOCK_ERROR_MSG = 'Unfortunately this product is out of stock and cannot be added to your shopping cart at this time.';

export const TOAST_TIMEOUT = 1000;

export const FAILURE_TOAST_TIMEOUT = 4000;
